import { Navigate } from 'react-router-dom';

// Passwordless model: registration no longer exists — redirect to the
// passwordless sign-in page (email -> 6-digit code).
export default function RegisterPage() {
  return <Navigate to="/login" replace />;
}
